/**
 * Whether this is a development build, for dev-only warnings. Web reads Vite's
 * `import.meta.env.DEV` (Metro's `__DEV__` isn't defined there).
 */
export const isDev = (): boolean => Boolean((import.meta as { env?: { DEV?: boolean } }).env?.DEV);
